export default "__VITE_ASSET__chDbHY5V__"